/* eslint-disable no-extra-boolean-cast */
import { useState } from "react";

function useLocalStorage<T>(key: string, initialValue?: T) {

  const [storedValue, setStoredValue] = useState<T>(() => {
    if (typeof window === "undefined") {
      return initialValue;
    }
    try {
      // Get from local storage by key
      const item = window.localStorage.getItem(key);
      // Parse stored json or if none return initialValue
      return !!item && item !== 'undefined' ? JSON.parse(item) : initialValue;
    } catch (error) {
      // If error also return initialValue
      console.log(error);
      return initialValue;
    }
  });
  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to localStorage.
  const setValue = (value: T | ((val: T) => T)) => {
    try {
      // Allow value to be a function so we have same API as useState
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;
      // Save state
      setStoredValue(valueToStore);
      // Save to local storage
      if (typeof window !== "undefined") {
        window.localStorage.setItem(key, JSON.stringify(valueToStore));
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Remove value in useState and localStorage
  const removeValue = () => {
    try {
      if (typeof window !== "undefined") {
        setStoredValue(null)
        window.localStorage.removeItem(key);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const recheckValue = () => {
    if (typeof window === "undefined") {
      return initialValue;
    }
    try {
      // Get from local storage by key
      const item = window.localStorage.getItem(key);
      // Parse stored json or if none return initialValue
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.log(error);
    }
  }

  return [storedValue, setValue, removeValue, recheckValue] as const;
}

export default useLocalStorage;